import React, { useState } from "react";
import { ModalUploadVideoContainer } from "./ModalUploadVideoStyled";
import camera from './../../utils/images/camera.svg';
import close from './../../utils/images/close_circle_outline.svg';
import { FormattedMessage } from 'react-intl';
import { getBase64 } from "../../services/generalSevices";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { postFileBase64 } from "../../api/fileApi";
import { postEditUserDataInfluencer, putEditUserDataCompany } from "../../api/myAccountApi";
import Spinner from "../Spinner/Spinner";
import edit from './../../utils/images/edit_white.svg';

export default function ModalUploadVideo({ setShowModalVideo }) {

    const { userToken, userType, uniqueName, account, videoProfile, setVideoProfile } = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(false);

    const saveProfileVideo = (e) => {
        setIsLoading(true);
        getBase64({ file: e.target.files[0] }).then((video) => {
            const videoBody = {
                base64File: video.split(',')[1],
                formatFile: e.target.files[0].type.split('/')[1]
            }
            if (userType === 'influencer') {
                //videoBody.address = `fluincr/${uniqueName}/profile`
                videoBody.address = `fluincr/${account}/profile`
            } else {
                //videoBody.address = `company/${uniqueName}/profile`
                videoBody.address = `company/${account}/profile`
            }

            postFileBase64({ body: videoBody, token: userToken }).then((responseVideo) => {

                if (responseVideo.length > 0) {
                    if (userType === 'influencer') {

                        postEditUserDataInfluencer({ body: { videoProfile: responseVideo }, token: userToken }).then((response) => {
                            if (response.status === 201) {
                                setVideoProfile(responseVideo)
                                setIsLoading(false)
                            }
                        })
                    } else if (userType === 'company') {
                        putEditUserDataCompany({ body: { videoProfile: responseVideo }, token: userToken }).then((response) => {
                            if (response.status === 201) {
                                setVideoProfile(responseVideo)
                                setIsLoading(false)
                            }
                        })
                    }
                }
            })

        });
    }

    return (
        <ModalUploadVideoContainer>

            <img src={close} alt="close" onClick={() => { setShowModalVideo(false) }} className="close" />

            {(videoProfile === null) ? (<div className="uploadContainer">
                <label htmlFor="video-file-input" className="fileLabel">
                    <img src={camera} alt="camera" className="cameraIcon" />
                    <p className="subTitle"><FormattedMessage id="my_profile_text_13" defaultMessage="Carga tu video de intro" /></p>
                    <p><FormattedMessage id="my_profile_text_14" defaultMessage="Preséntate con tus seguidores y cuentanos de ti." /></p>
                    <p><FormattedMessage id="my_profile_text_15" defaultMessage="Formato mp4 - mov - flv" /></p>
                </label>

                <input type="file" id="video-file-input" accept="video/mp4,video/x-m4v, video/mov, video/*" onChange={(e) => {
                    saveProfileVideo(e)
                }} />
            </div>) : (<div className="videoContainer">
                <div className="videoEdit">
                    <label htmlFor="edit-video-file-input" className="fileLabel">
                        <img src={edit} alt="edit" className="editPhoto" />
                    </label>

                    <input type="file" id="edit-video-file-input" accept="video/mp4,video/x-m4v, video/mov, video/*" onChange={(e) => {
                        saveProfileVideo(e)

                    }} />
                </div>
                <video src={videoProfile} className="video" controls={true}></video></div>)}



            {(isLoading) && (<Spinner />)}

        </ModalUploadVideoContainer>
    )
}